/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

// export const ON_CALL_UPLOAD = 'boilerplate/Landing/ON_CALL_UPLOAD'
export const LOADER_STATUS = "DATA_ANALYTICS/LOADER_STATUS";
export const PROFILE_INFO = "DATA_ANALYTICS/PROFILE_INFO";
export const SET_VARIANCE_DATA = "DATA_ANALYTICS/SET_VARIANCE_DATA";

export const SET_CLEAR_GRAPH = "LEDGER_BAL/SET_CLEAR_GRAPH";
export const SET_AGG_CASH_TOTAL_DATA = "LEDGER_BAL/SET_AGG_CASH_TOTAL_DATA";
export const SET_AGG_ITC_TOTAL_DATA = "LEDGER_BAL/SET_AGG_ITC_TOTAL_DATA";
export const SET_GSTIN_CASH_DATA = "LEDGER_BAL/SET_GSTIN_CASH_DATA";
export const SET_GSTIN_ITC_DATA = "LEDGER_BAL/SET_GSTIN_ITC_DATA";
export const SET_LED_ITC_BAL_DATA = "LEDGER_BAL/SET_LED_ITC_BAL_DATA";
export const SET_RET_PER_DATA = "LEDGER_BAL/SET_RET_PER_DATA";
